/*
 * Fixes: selecting a color/size inside the "Bundle & Save" (quantity_breaks)
 * inline variant selectors did not update the main product image, because
 * those selectors live outside Dawn's <variant-selects> element and only
 * write to a hidden form field. This script watches those selectors and
 * swaps the visible media directly.
 *
 * Note: the classic product JSON endpoint's `variant.featured_image.id` uses
 * the legacy Image API id space, which does NOT match the `media.id` used by
 * product.media / the theme's media-gallery data-media-id attributes. So we
 * resolve the correct media id by fetching the rendered section HTML for the
 * target variant (the same technique Dawn's own product-info.js uses) rather
 * than trying to compute/guess the id ourselves.
 */
(function () {
  if (!/\/products\//.test(window.location.pathname)) return;

  var productDataCache = null;
  var mediaIdCache = {};

  function fetchProductData(cb) {
    var path = window.location.pathname.split('?')[0].replace(/\/$/, '') + '.js';
    fetch(path)
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function () {});
  }

  function withProductData(cb) {
    if (productDataCache) {
      cb(productDataCache);
      return;
    }
    fetchProductData(function (data) {
      productDataCache = data;
      cb(data);
    });
  }

  function findVariant(product, optionValuesByPosition) {
    return product.variants.find(function (v) {
      return optionValuesByPosition.every(function (val, idx) {
        return v.options[idx] === val;
      });
    });
  }

  function fetchVariantMediaId(sectionId, variantId, cb) {
    var cacheKey = sectionId + ':' + variantId;
    if (mediaIdCache[cacheKey] !== undefined) {
      cb(mediaIdCache[cacheKey]);
      return;
    }
    var basePath = window.location.pathname.split('?')[0];
    var url = basePath + '?variant=' + variantId + '&section_id=' + sectionId;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var activeItem =
          doc.querySelector('media-gallery [data-media-id].is-active') ||
          doc.querySelector('media-gallery [data-media-id]');
        var mediaId = activeItem ? activeItem.getAttribute('data-media-id') : null;
        mediaIdCache[cacheKey] = mediaId;
        cb(mediaId);
      })
      .catch(function () { cb(null); });
  }

  function updateImageForRow(row) {
    var productInfo = row.closest('product-info');
    if (!productInfo) return;
    var sectionId = productInfo.dataset.section;
    var gallery = productInfo.querySelector('media-gallery') || document.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    var opts = [];
    row.querySelectorAll('.qb-iv-sel').forEach(function (sel) {
      opts.push(sel.value);
    });
    if (!opts.length) return;

    withProductData(function (product) {
      if (!product) return;
      var variant = findVariant(product, opts);
      if (!variant) return;
      fetchVariantMediaId(sectionId, variant.id, function (mediaId) {
        if (mediaId) gallery.setActiveMedia(mediaId, true);
      });
    });
  }

  function bindRow(row) {
    if (row.dataset.erdensaiImgBound === '1') return;
    row.dataset.erdensaiImgBound = '1';
    row.querySelectorAll('.qb-iv-sel').forEach(function (sel) {
      sel.addEventListener('change', function () {
        updateImageForRow(row);
      });
    });
  }

  function scan() {
    document.querySelectorAll('.qb-iv-row[data-item="0"]').forEach(function (row) {
      bindRow(row);
    });
  }

  scan();

  var mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
